import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import Gikam from '../../../core/gikam-core';
import { I18N } from '@/gikam/i18n/I18N';

function isColumnVisible(fieldOption) {
  var visible = fieldOption.visible;
  return visible === undefined || visible === '1' || visible === true;
}

var GridConfig = /*#__PURE__*/function () {
  function GridConfig(store) {
    _classCallCheck(this, GridConfig);

    this.store = store;
    this.init();
  }

  _createClass(GridConfig, [{
    key: "initModal",
    value: function initModal() {
      var _this2 = this;

      var _this = this;

      var result = Gikam.createSimpleModal({
        title: I18N.prop('grid.configuration'),
        width: 600,
        height: 400,
        toolbarFormatter: function toolbarFormatter(toolbar) {
          toolbar.unshift({
            type: 'button',
            text: I18N.prop('grid.configuration.restore'),
            onClick: function onClick() {
              _this.revertDefault();
            }
          });
          return toolbar;
        },
        onConfirm: function onConfirm() {
          return _this2.confirm();
        },
        onCancel: function onCancel() {
          return _this2.cancel();
        }
      });
      this.modal = result.modal;
      this.layout = result.layout;
    }
  }, {
    key: "revertDefault",
    value: function revertDefault() {
      var _this3 = this;

      if (this.store.getters.defaultColumns.length === 0) {
        return;
      }

      this.modal.window.showMask();
      var defaultColumns = this.store.getters.defaultColumns.filter(function (item) {
        return item.field;
      });
      defaultColumns.forEach(function (item) {
        if (Gikam.isNotEmpty(item.fixed)) {
          item.fixed = item.fixed === true ? '1' : '0';
        }
      });
      this.updateColumns(defaultColumns).done(function () {
        _this3.store.commit('refreshColumns', Gikam.deepExtend(_this3.store.getters.defaultColumns));

        _this3.modal.close();
      }).always(function () {
        return _this3.modal.window.closeMask();
      });
    }
  }, {
    key: "confirm",
    value: function confirm() {
      var _this4 = this;

      var newColumns = this.grid.getData();
      newColumns.forEach(function (item) {
        return delete item.index;
      });
      var finalColumns = this.store.state.columns.filter(function (item) {
        return item.checkbox || item.radio || item.index === true;
      }).concat(newColumns);
      this.modal.window.showMask();
      this.updateColumns(newColumns).done(function () {
        _this4.store.commit('refreshColumns', finalColumns);

        _this4.modal.close();
      }).always(function () {
        return _this4.modal.window.closeMask();
      });
    }
  }, {
    key: "updateColumns",
    value: function updateColumns(newColumns) {
      var url = Gikam.IFM_CONTEXT + '/core/module/sys/page-grid-field-configs';
      var _this$store$state = this.store.state,
          gridId = _this$store$state.gridId,
          $window = _this$store$state.$window;
      return Gikam.postText(url, Gikam.getJsonWrapper({
        gridId: gridId,
        pageId: $window.getMainPageUrl()
      }, ['', newColumns]));
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.modal.close();
    }
  }, {
    key: "getGridData",
    value: function getGridData() {
      return Gikam.deepExtend(this.store.state.columns).filter(function (item) {
        return item.field;
      }).map(function (item) {
        return Gikam.extend(item, {
          fixed: isColumnVisible(item) && item.fixed == true ? '1' : '0',
          visible: !isColumnVisible(item) ? '0' : '1',
          title: Gikam.propI18N(item.title)
        });
      });
    } // 获取配置列表头数据

  }, {
    key: "getColumns",
    value: function getColumns() {
      var _this = this;

      return [{
        title: I18N.prop('grid.configuration.columnName'),
        field: 'title',
        width: 180
      }, {
        title: I18N.prop('grid.configuration.sort'),
        type: 'drag',
        width: 134
      }, {
        title: I18N.prop('grid.configuration.show'),
        field: 'visible',
        width: 134,
        type: 'simpleCheckbox',
        editor: true,
        onChange: function onChange(field, val, row) {
          if (val === '0') {
            _this.grid.toFieldsReadonly(row, ['fixed']);

            _this.grid.setData({
              index: row,
              fixed: '0'
            });
          } else {
            _this.grid.toFieldsEdit(row, ['fixed']);
          }
        }
      }, {
        title: I18N.prop('grid.configuration.frozen'),
        field: 'fixed',
        type: 'simpleCheckbox',
        editor: true
      }];
    }
  }, {
    key: "initGrid",
    value: function initGrid() {
      var _this5 = this;

      var _this = this;

      this.grid = Gikam.create('grid', {
        renderTo: this.layout.options.center.$dom,
        page: false,
        fill: true,
        filter: false,
        autoSave: false,
        editorInvisible: true,
        generalButtonGroup: false,
        columns: _this.getColumns(),
        columnsFill: true,
        data: this.getGridData()
      });
      this.getGridData().forEach(function (item, index) {
        item.visible === '0' && _this5.grid.toFieldsReadonly(index, ['fixed']);
      });
    }
  }, {
    key: "initForm",
    value: function initForm() {
      var _this = this;

      var gridData = this.grid.getData();
      this.form = Gikam.create('form', {
        renderTo: this.modal.window.model.$refs.vm.$refs['toolbar'],
        onRendered: function onRendered() {
          this.setData({
            visibleAll: '0'
          });
        },
        columns: 1,
        fields: [{
          field: 'visibleAll',
          type: 'checkbox',
          showAllCheck: false,
          items: [{
            text: I18N.prop('grid.configuration.show.all.columns'),
            value: '0'
          }],
          onChange: function onChange(field, value) {
            if (Gikam.isNotEmpty(value)) {
              gridData.forEach(function (item, index) {
                _this.grid.setData({
                  index: index,
                  visible: '1'
                });

                _this.grid.toFieldsEdit(index, ['fixed']);
              });
            } else {
              gridData.forEach(function (item, index) {
                _this.grid.setData({
                  index: index,
                  visible: '0'
                });

                _this.grid.toFieldsReadonly(index, ['fixed']);
              });
            }
          }
        }]
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.initModal();
      this.initGrid();
      this.initForm();
    }
  }]);

  return GridConfig;
}();

export { GridConfig as default };